import { Navigate, useLocation } from "react-router-dom";
import { type ReactNode } from "react";
import { useAuthStore } from "@/stores/authStore.ts";

interface ProtectedRouteProps {
  children: ReactNode;
}

/**
 * Redirects to /login with a return-to query param if the user isn't
 * authenticated or their token has expired.
 */
export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated());
  const location = useLocation();

  if (!isAuthenticated) {
    return (
      <Navigate
        to={`/login?return=${encodeURIComponent(location.pathname + location.search)}`}
        replace
      />
    );
  }

  return <>{children}</>;
}
